'use client'

import React, { useState } from 'react'
import Modal from '../../Modal'
import Text from '../../Text'
import Spacer from '../../Spacer'
import Cta from '../../Cta'
import SimpleBlockContent from '../../SimpleBlockContent'
import styles from './styles.module.css'

import { $neutralGray80, $white } from '../../../styles/colors/primitives'



function TripleImages({ images, theme = {}, title, text, reversed, cta }) {
  // Phase B: the lightbox holds the clicked image src in LOCAL component state.
  const [modalImageSrc, setModalImageSrc] = useState(null)
  // task #67: images[].image is now a ResolvedImage descriptor; key the modal off its resolved .src
  const imageIds = [images[0].image?.src, images[1].image?.src, images[2].image?.src]

  const themeColorValue = theme.title.match(/\d+/) ? Number(theme.title.match(/\d+/)[0]) : null
  const textColor = themeColorValue && themeColorValue > 40 ? $white : $neutralGray80
  const dark = themeColorValue && themeColorValue < 50

  return (
    <div className={styles.wrapper} style={{ backgroundColor: theme.value }}>
      <Spacer size={96} />
      <div className={styles.contentWrapper}>
        <div className={styles.column}>
          <div className={reversed ? `${styles.textWrapper} ${styles.reversed}` : styles.textWrapper}>
            <div style={{ color: textColor }}>
              {text && <SimpleBlockContent blocks={text} />}
            </div>
          </div>
          <div className={styles.imageWrapper} onClick={() => setModalImageSrc(images[0].image?.src)}>
            {/* eslint-disable-next-line @next/next/no-img-element, local-rules/prefer-img-component, local-rules/no-raw-media-src, local-rules/img-requires-dimensions -- resolved-descriptor content image, sized 100%/100% by CSS */}
            <img className={styles.image} src={images[0]?.image?.src} alt={images[0].description}/>
            <div className={styles.plusIcon} />
          </div>
          <div style={{ color: textColor }}>
            <Text type="body-long-2">{images[0].description}</Text>
          </div>
          <Spacer size={40} />
			  { cta &&
				  <div className={styles.ctaWrapper}>
				  <Cta {...cta} key={cta ? cta._key : ''} fixedSecondaryColor={true} dark={dark}/>
				  </div>
			  }
        </div>
        <div className={styles.column}>
          <div className={styles.imageWrapper} onClick={() => setModalImageSrc(images[1].image?.src)}>
            {/* eslint-disable-next-line @next/next/no-img-element, local-rules/prefer-img-component, local-rules/no-raw-media-src, local-rules/img-requires-dimensions -- resolved-descriptor content image, sized 100%/100% by CSS */}
            <img className={styles.image} src={images[1]?.image?.src} alt={images[0].description}/>
            <div className={styles.plusIcon} />
          </div>
          <div style={{ color: textColor }}>
            <Text type="body-long-2">{images[1].description}</Text>
          </div>
        </div>
        <div className={styles.column}>
          <Spacer size={40} />
          <div className={styles.imageWrapper} onClick={() => setModalImageSrc(images[2].image?.src)}>
            {/* eslint-disable-next-line @next/next/no-img-element, local-rules/prefer-img-component, local-rules/no-raw-media-src, local-rules/img-requires-dimensions -- resolved-descriptor content image, sized 100%/100% by CSS */}
            <img className={styles.image} src={images[2]?.image?.src} alt={images[0].description}/>
            <div className={styles.plusIcon} />
          </div>
          <div style={{ color: textColor }}>
            <Text type="body-long-2">{images[2].description}</Text>
          </div>
        </div>
      </div>
      <Spacer size={48} />
      {modalImageSrc && <Modal show={imageIds.indexOf(modalImageSrc) >= 0} onClose={() => setModalImageSrc(null)}>
        <div className={styles.modalImageWrapper}>
          <button className={styles.closeButton} onClick={() => setModalImageSrc(null)}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            {/* eslint-disable-next-line local-rules/prefer-img-component -- inline chrome icon (close), hand-sized 24x24 from /public */}
            <img src="/crossIcon.svg" alt="Close" width={24} height={24} decoding="async" />
          </button>
          {/* eslint-disable-next-line @next/next/no-img-element, local-rules/prefer-img-component, local-rules/no-raw-media-src, local-rules/img-requires-dimensions -- resolved-descriptor content image, sized by CSS (max 90%/90%) */}
          <img className={styles.modalImage} alt="" src={images.find((image) => {
            return image.image?.src === modalImageSrc
          }).image?.src} />
        </div>
      </Modal>}
    </div>
  )
}

export default TripleImages
